var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gotop-container",class:_vm.showGoTop ? 'active' : ''},[_c('span',{staticClass:"icon iconfont icon-fanhui",on:{"click":_vm.onReturn}}),_c('span',{staticClass:"icon iconfont icon-fanhuidingbu",on:{"click":_vm.onGoTop}})])}
var staticRenderFns = []

export { render, staticRenderFns }